import { render, staticRenderFns } from "./GramsTable.vue?vue&type=template&id=4bff061a&"
import script from "./GramsTable.vue?vue&type=script&lang=js&"
export * from "./GramsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports